module.exports = __webpack_public_path__ + "static/umi-04333c67f440b1f64f5f256ddee7f254.svg";